"use strict";

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

exports.__esModule = true;

var GUID_1 = require("./GUID");

var Timing = require("./methods/timing");

var Count = require("./methods/count");

var Assert = require("./methods/assert");
/**
 * Parses a console log and converts it to a special Log object
 * @argument method The console method to parse
 * @argument data The arguments passed to the console method
 */


function Parse(method, data, staticID) {
  // Create an ID
  var id = staticID || GUID_1["default"](); // Parse the methods

  switch (method) {
    case 'clear':
      {
        return {
          method: method,
          id: id
        };
      }

    case 'count':
      {
        var label = typeof data[0] === 'string' ? data[0] : 'default';
        if (!label) return false;
        return __assign({}, Count.increment(label), {
          id: id
        });
      }

    case 'time':
    case 'timeEnd':
      {
        var label = typeof data[0] === 'string' ? data[0] : 'default';
        if (!label) return false;

        if (method === 'time') {
          Timing.start(label);
          return false;
        }

        return __assign({}, Timing.stop(label), {
          id: id
        });
      }

    case 'assert':
      {
        var valid = data.length !== 0;

        if (valid) {
          var assertion = Assert.test.apply(Assert, [data[0]].concat(data.slice(1)));

          if (assertion) {
            return __assign({}, assertion, {
              id: id
            });
          }
        }

        return false;
      }

    case 'error':
      {
        var errors = data.map(function (error) {
          try {
            return error.stack || error;
          } catch (e) {
            return error;
          }
        });
        return {
          method: method,
          id: id,
          data: errors
        };
      }

    default:
      {
        return {
          method: method,
          id: id,
          data: data
        };
      }
  }
}

exports["default"] = Parse;